module.exports = __webpack_public_path__ + "img/album18_30.a78c65f2.jpg";